const hotels = {
  accommodation: "आवास", // translated 
  hotel: "होटल", // translated 
  hotels: "होटल", // translated 
  back: "पीछे", // translated 
  rooms: "कमरा", // translated 
  viewPictures: "चित्र देखें", // translated 
  showMore: "और दिखाएँ", // translated 
  bookingInformation: "बुकिंग जानकारी", // translated 
  cancellationPolicy: "रद्द करने की नीति", // translated 
  from: "से", // translated 
  to: "Προς την", // translated 
  cancellationIs: "रद्दीकरण है", // translated 
  free: "मुक्त", // translated 
  chargeableWithFeeOf: "शुल्क सहित प्रभार्य", // translated 
  prebook: "पहले से बुकिंग करें", // translated 
  guests: "अतिथियों", // translated 
  payment: "भुगतान", // translated 
  byClicking: "क्लिक करके", // translated 
  next: "अगला", // translated 
  youAreAgreeingToOur: "आप हमारी शर्तों से सहमत हो रहे हैं।", // translated 
  termsAndConditions: "नियम और शर्तें", // translated 
  previous: "पहले का", // translated 
  cancel: "रद्द करना", // translated 
  mealPlan: "भोजन की योजना", // translated 
  roomType: "कमरे के प्रकार", // translated 
  description: "विवरण", // translated 
  readLess: "कम पढ़ें", // translated 
  readMore: "और पढ़ें", // translated 
  facilities: "सुविधाएँ", // translated 
  viewLess: "कम देखें", // translated 
  viewMore: "और देखें", // translated 
  less: "कम", // translated 
  more: "अधिक", // translated 
  notAvailable_short: "लागू नहीं", // translated 
  backToHotelList: "होटल सूची पर वापस जाएँ", // translated 
  viewOnMap: "मानचित्र पर देखें", // translated 
  sleeps: "सोता", // translated 
  adults: "वयस्कों", // translated 
  yearsOld: "वर्षों पुराना", // translated 
  type: "प्रकार", // translated 
  bedding: "बिस्तर", // translated 
  selectRoom: "कमरा चुनें", // translated 
  selectRooms: "कमरे चुनें", // translated 
  city: "शहर", // translated 
  checkIn: "चेक इन", // translated 
  checkOut: "चेक आउट", // translated 
  date: "तारीख", // translated 
  dates: "खजूर", // translated 
  persons: "व्यक्तियों", // translated 
  stillOnTrialQuestionToUpgrade:
    "माफ़ कीजिए! ऐसा लगता है कि आप अभी भी ट्रायल मेंबरशिप पर हैं। बुकिंग करने के लिए आपको मेंबरशिप की पक्की सदस्यता लेनी होगी। क्या आप अभी अपनी सदस्यता अपग्रेड करना चाहेंगे?", // translated 
  stillOnTrialQuestionToUpgradeNonElligib:
    "माफ़ कीजिए! लगता है आपने अभी तक सदस्यता नहीं ली है। बुकिंग करने के लिए आपको एक पुष्ट सदस्य होना ज़रूरी है। क्या आप अभी सदस्यता बढ़ाना चाहेंगे?", // translated 
  completeProfile: "कृपया पहले अपनी उपयोगकर्ता प्रोफ़ाइल पूरी करें", // translated 
  upgrade: "Αναβαθμίζω", // translated 
  close: "बंद करना", // translated 
  viewDetails: "विवरण देखें", // translated 
  name: "नाम", // translated 
  rating: "रेटिंग", // translated 
  budget: "बजट", // translated 
  orderBy: "द्वारा आदेश", // translated 
  priceLowestFirst: "क़ीमत: पहला सबसे कम)", // translated 
  priceHighestFirst: "मूल्य: उच्चतम पहले)", // translated 
  ratingLowestFirst: "रेटिंग (सबसे कम से शुरू)", // translated 
  ratingHighestFirst: "रेटिंग (सबसे पहले उच्चतम)", // translated 
  starRatingAndPrice: "स्टार रेटिंग और कीमत", // translated 
  biggestSavingsFirst: "सबसे पहले सबसे बड़ी बचत", // translated 
  select: "चुनना", // translated 
  reset: "रीसेट करें", // translated 
  apply: "आवेदन करना", // translated 
  filterBy: "फिल्टर के द्वारा", // translated 
  myProfile: "मेरी प्रोफाइल", // translated 
  login: "लॉग इन करें", // translated 
  roomOnly: "सिर्फ कमरा", // translated 
  bedAndBreakfast: "बिस्तर और नाश्ता", // translated 
  halfBoard: "समुचित व्यवस्था", // translated 
  fullBoard: "पूर्ण बोर्ड", // translated 
  allInclusive: "सभी समावेशी", // translated 
  filter: "फ़िल्टर", // translated 
  mapView: "मानचित्र दृश्य", // translated 
  results: "परिणाम", // translated 
  listView: "लिस्ट व्यू", // translated 
  newSearch: "नई खोज", // translated 
  editSearch: "खोज संपादित करें", // translated 
  all: "सभी", // translated 
  multiple: "विभिन्न", // translated 
  editProfile: "प्रोफ़ाइल संपादित करें", // translated 
  backToHotelsList: "होटलों की सूची पर वापस जाएँ", // translated 
  roomName: "कमरे का नाम", // translated 
  mealType: "भोजन का प्रकार", // translated 
  freeCancellation: "मुफ़्त निराकरण", // translated 
  yes: "हाँ", // translated 
  no: "Οχι", // translated 
  filters: "फिल्टर", // translated 
  cancellationNonRefundable: "रद्द करने पर कोई धन वापसी नहीं होगी।", // translated 
  hotelRating: "होटल रेटिंग", // translated 
  any: "कोई", // translated 
  off: "बंद", // translated 
  performNewSearch: "नई खोज करें", // translated 
};


export default hotels;
